import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1440",
  height: "880",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3643BA",
      d: "M0 0h1440v880H0z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1469",
      cy: "631",
      r: "262.5",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1266",
      cy: "743",
      r: "262.5",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1)
  ]))]))
}
export default { render: render }